import { Button, Dialog } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

export const CanvaOriginalPostClosedModal = (): JSX.Element => (
  <Dialog open>
    <Dialog.Content size="medium">
      <Dialog.Header>
        <Dialog.Title>Original post closed</Dialog.Title>
      </Dialog.Header>
      <Dialog.Body>
        Canva can only deliver images when your original post editor is still
        open. Please return to the post editor in Buffer, then try again.
      </Dialog.Body>

      <Dialog.Footer>
        <Button onClick={() => window.close()}>Close this window</Button>
      </Dialog.Footer>
    </Dialog.Content>
  </Dialog>
)
